import { render, staticRenderFns } from "./VideoTabView.vue?vue&type=template&id=cfa5078a&scoped=true&"
import script from "./VideoTabView.vue?vue&type=script&lang=js&"
export * from "./VideoTabView.vue?vue&type=script&lang=js&"
import style0 from "./VideoTabView.vue?vue&type=style&index=0&id=cfa5078a&lang=scss&scoped=true&"
import style1 from "./VideoTabView.vue?vue&type=style&index=1&id=cfa5078a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa5078a",
  null
  
)

export default component.exports